/* eslint-disable @typescript-eslint/naming-convention */
import {AppEnum} from './app.enum';

const AppConstant = {
  APP_INSTALL_MESSAGE: 'Add it to your home screen for quick access and an enhanced experience!',
  APP_INSTALL_HEADER: 'Install MS-Chatbox',
  APP_UPDATE_HEADER: 'A new version of App is available!',
  APP_UPDATE_MSG: 'Please click on install button to get the latest changes!',
  LOGIN_BASE_URL: '/api/auth',
  MEETING_URL: '/api/meetings',
  MENU_WHITELISTED_URL: '/dealer/login',
  ASSIGNED_TO_TL: '/api/meetings/assigned_to_tl',
  INTECEPTOR_EXCEPTION_PATH: ['/api/auth', '/api/v2/customer', '/api/customer'],
  WBX_T_KEY: 'access_token',
  VALIDATORS: {
    EMAIL: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
    MOBILE: '^[6789]\\d{9}$',
  },
  MEETING_CONSTANT: {
    TOT_MEET_CARD_TITLE: 'Total ',
    ACTIVE_MEET_CARD_TITLE: 'Active',
    INCOMPLETE_MEET_CARD_TITLE: 'Incomplete',
    MISSED_MEET_CARD_TITLE: 'Missed',
    COMPLETED_MEET_CARD_TITLE: 'Completed',
    CANCELED_MEET_CARD_TITLE: 'Cancelled',
  },
  STORAGE_KEYS: {
    SIT_T: 'sit-t',
    SIT_R_T: 'sit-r-t',
    SIT_D_MSPIN: 'sit-d-mspin',
    SIT_WBX_TKN: 'sit-wbx-tkn',
    SIT_G_WBX_TKN: 'sit-g-wbx-tkn',
    STT_WS_TKN: 'sit-ws-tkn',
    SIT_CUST_T: 'sit-cust-t',
  },
  TOST_MSG: {
    CUST_JOINED_MEETING: 'has joined the meeting',
    REINITIATE_IMMERSIVE_VIEW: 'Restarting the immersive view',
    THREE_D_LOADED: '3D Model loaded at Customer side',
    APP_OFFLINE: 'Internet connection is lost.',
    APP_ONLINE: 'Internet connection restored.',
  },
  APP_MENU_CONFIG: [
    {
      title: AppEnum.MENU_MEETING,
      url: '/dealer/meeting',
      icon: 'assets/icons/dashboard.svg',
    },
    {
      title: AppEnum.MENU_ENQUIRIES,
      url: '/dealer/enquiry',
      icon: 'assets/icons/enquiry.svg',
    },
    // {
    //   title: AppEnum.MENU_DOCUVAULT,
    //   url: '/dealer/doc',
    //   icon: 'assets/icons/folder-zip.svg',
    // },
    {
      title: AppEnum.MENU_HOWTOUSE,
      url: '',
      icon: 'assets/icons/video-clip.svg',
    },
    {title: AppEnum.MENU_FAQ, url: '/dealer/faq', icon: 'assets/icons/chat.svg'},
    {
      title: AppEnum.MENU_LOGOUT,
      url: '/dealer/log-out',
      icon: 'assets/icons/arrow-exit.svg',
    },
  ],
  CAR_DUMMY_THUMB_IMG: 'car-dummy.svg',
  CAR_DUMMY_COLOR_IMG: 'dummy-color.webp',
  CAR_DUMMY_BRAND_IMG: 'brand.svg',
};
export default AppConstant;
